import { useState, useContext, useEffect, useRef } from "react";
import EventForm from "./_components/EventForm";
import EventList from "./_components/EventList";
import { OperaContext } from "../../../context/OperaContext";

function EventTab() {
  const {
    fetchAdminData,
    loading,
    prePopulateEventData,
    setEventFormDataEdit,
    eventFormDataEdit,
  } = useContext(OperaContext);
  const [error, setError] = useState(null);
  const formContainerRef = useRef(null);
  const [isSectionOpen, setIsSectionOpen] = useState(false);

  useEffect(() => {
    const loadData = async () => {
      try {
        setError(null);
        await fetchAdminData();
      } catch (err) {
        setError("Failed to load events: " + err.message);
      }
    };
    loadData();
  }, [fetchAdminData]);

  // Scroll to top when editing an event
  useEffect(() => {
    if (eventFormDataEdit && formContainerRef.current) {
      // Use a small timeout to ensure the form is rendered
      setTimeout(() => {
        const yOffset = -20; // Add a small offset for better UX
        const y =
          formContainerRef.current.getBoundingClientRect().top +
          window.pageYOffset +
          yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
      }, 100);
    }
  }, [eventFormDataEdit]);

  // Create a custom setter for editingEvent that wraps the original function
  const handleEditEvent = (event) => {
    setEventFormDataEdit(event);
  };

  if (loading) {
    return <p className="text-[#ccc] text-center">Loading events...</p>;
  }

  return (
    <div className="max-w-[1280px] mx-auto p-4 md:p-8 bg-[#1a1a1a] rounded-lg text-white">
      <div ref={formContainerRef}>
        {error && <p className="text-[#f44336] text-center mb-4">{error}</p>}
        <EventForm
          editingEvent={eventFormDataEdit}
          setEditingEvent={setEventFormDataEdit}
          prePopulateData={prePopulateEventData}
          isSectionOpen={isSectionOpen}
          setIsSectionOpen={setIsSectionOpen}
        />
      </div>
      <EventList onEditEvent={handleEditEvent} />
    </div>
  );
}

export default EventTab;
